import { Component, Input, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IObjectivesFormState } from '../../../store/objective.state';
import { setObjectiveEntrepreneurshipAction } from '../../../store/objective.actions';
import { getObjectiveEntrepreneurshipSelectors } from '../../../store/objective.selectors';
import { IGoalsResponse } from 'src/app/modules/interfaces/goals-dto.interface';
import { GoalsService } from 'src/app/services/goals.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-entrepreneurship',
  templateUrl: './entrepreneurship.component.html',
  styleUrls: ['./entrepreneurship.component.scss'],
})
export class EntrepreneurshipComponent implements OnInit {
  @Input() data: IGoalsResponse;
  selectedGoals: number[] = [];
  formsId: number = 0;
  check: number = 0;
  isLoading: boolean = false;
  buttonText: string = 'Salvar';

  panelOpenState = true;
  dataStoreEntrepreneurship$: Observable<any>;
  dataStoreEntrepreneurship: IObjectivesFormState;

  constructor(
    private store: Store,
    private readonly goalsService: GoalsService
  ) {
    this.formsId = Number(getCookie('formsId'));
  }

  ngOnInit(): void {
    this.loadSelectedGoals();
    this.getState();
    this.setValuesForm();
    this.saveState();
  }

  loadSelectedGoals() {
    this.goalsService.getSelectedGoals(this.formsId).subscribe((res: any) => {
      this.selectedGoals = res.data || [];
    });
  }

  getState(): void {
    this.dataStoreEntrepreneurship$ = this.store.select(
      getObjectiveEntrepreneurshipSelectors
    );
    this.dataStoreEntrepreneurship$.subscribe((value) => {
      this.dataStoreEntrepreneurship = {
        ...(this.dataStoreEntrepreneurship = value),
      };
    });
  }

  UpdateGoals() {
    this.goalsService
      .createGoals(this.formsId, this.selectedGoals)
      .subscribe(() => {
        this.dataStoreEntrepreneurship = {
          ...this.dataStoreEntrepreneurship,
          isSelected: !this.dataStoreEntrepreneurship.isSelected,
        };
        this.setState(this.dataStoreEntrepreneurship);
        window.location.reload();
      });
  }

  unCheck(): void {
    const goalId = 5;
    this.selectedGoals = this.selectedGoals.filter((id) => id !== goalId);
    this.UpdateGoals();
  }

  saveForm(): void {
    const goalData = {
      check: this.check,
      motive: this.data.motive,
      target_date: this.data.target_date,
      investment_min: this.data.investment_min,
      investment_max: this.data.investment_max,
      observation: this.data.observation,
    };

    this.isLoading = true;
    this.buttonText = 'Salvando...';

    this.goalsService
      .updateGoals(this.formsId, this.data.id, goalData)
      .subscribe({
        next: () => {
          this.panelOpenState = false;
          this.saveState();
          this.isLoading = false;
          this.buttonText = 'Salvar';
        },
        error: (err) => {
          console.error('Erro ao salvar', err);
          this.isLoading = false;
          this.buttonText = 'Salvar';
        },
      });
  }

  saveState(): void {
    this.dataStoreEntrepreneurship = {
      ...this.dataStoreEntrepreneurship,
      isSelected: true,
      check: Boolean(this.check),
      description: this.data.motive,
      date: new Date(this.data.target_date),
      minimumInvestment: this.data.investment_min,
      maximumInvestment: this.data.investment_max,
      observation: this.data.observation,
    };
    this.setState(this.dataStoreEntrepreneurship);
  }

  setState(data: IObjectivesFormState) {
    this.store.dispatch(setObjectiveEntrepreneurshipAction(data));
  }

  setValuesForm(): void {
    this.check =
      !!this.data.motive &&
      !!this.data.target_date &&
      !!this.data.investment_max
        ? 1
        : 0;

    this.data.check =
      !!this.data.motive &&
      !!this.data.target_date &&
      !!this.data.investment_max
        ? 1
        : 0;
    this.dataStoreEntrepreneurship.check = this.check === 1 ? true : false;
    this.setState(this.dataStoreEntrepreneurship);
  }

  updateInvestmentAmount(type: 'min' | 'max', event: any): void {
    if (type === 'min') {
      this.data.investment_min = event;
    } else {
      this.data.investment_max = event;
    }
    this.setValuesForm();
  }
}
